import React, { createContext, useState, useContext, useEffect } from 'react';

export const MenuCategoryContext = createContext({});

const STORAGE_KEY = 'karsan_selected_category';

export const MenuCategoryProvider = ({ children }) => {
    // localStorage'dan başlangıç değerini al
    const [selectedCategory, setSelectedCategoryState] = useState(() => {
        try {
            const stored = localStorage.getItem(STORAGE_KEY);
            return stored || null;
        } catch (error) {
            console.error('Error reading from localStorage:', error);
            return null;
        }
    });

    // selectedCategory değiştiğinde localStorage'a kaydet
    const setSelectedCategory = (category) => {
        setSelectedCategoryState(category);
        try {
            if (category) {
                localStorage.setItem(STORAGE_KEY, category);
            } else {
                localStorage.removeItem(STORAGE_KEY);
            }
        } catch (error) {
            console.error('Error writing to localStorage:', error);
        }
    };

    const value = {
        selectedCategory,
        setSelectedCategory
    };

    return <MenuCategoryContext.Provider value={value}>{children}</MenuCategoryContext.Provider>;
};

export const useMenuCategory = () => {
    const context = useContext(MenuCategoryContext);
    if (!context) {
        throw new Error('useMenuCategory must be used within MenuCategoryProvider');
    }
    return context;
};
